import type { Dict } from "../lib/i18n";

// Keys are prefixed "places." — keep zh / en / nl in step.
export default {
  zh: {
    "places.offers.title": "优惠和推荐",
    "places.offers.all": "全部",
    "places.business.title": "商家合作：让附近的家庭看到你的店",
    "places.business.body": "超市、小店、餐馆或服务商都可以在这里展示优惠和推荐。留下联系方式，我们会尽快联系你。",
    "places.business.cta": "联系我们",
    "places.business.formTitle": "商家合作",
    "places.business.formIntro": "填写下面的信息，我们会在 2 个工作日内回复你。",
    "places.business.name": "店名或公司名",
    "places.business.kind": "类型",
    "places.business.contact": "联系人",
    "places.business.replyTo": "邮箱或电话",
    "places.business.replyToPh": "我们用它回复你",
    "places.business.city": "城市",
    "places.business.message": "想说的话（可不填）",
    "places.business.messagePh": "例如：想推一个开业优惠",
    "places.business.send": "发送",
    "places.business.sent": "已发送，我们会尽快联系你。谢谢！",
    "places.title": "附近商家",
    "places.heroSub": "合作商家的优惠，以及你附近的超市、小店和餐馆。",
    "places.type.supermarket": "超市",
    "places.type.shop": "商店",
    "places.type.food": "餐饮",
    "places.type.service": "服务",

    "places.partners": "合作商家",
    "places.partners.offer": "优惠",
    "places.partners.website": "访问网站",
    "places.partners.none.title": "想让你的店出现在这里？",
    "places.partners.none.body": "给我们发邮件，我们会告诉你怎么合作。",
    "places.partners.none.soon": "联系方式即将公布。",
    "places.copy": "复制邮箱地址",
    "places.copied": "邮箱地址已复制",
    "places.copyFailed": "复制失败，请长按地址手动选择。",

    "places.near": "你的附近",
    "places.near.intro": "用你的位置或搜索一个地点，查看周围约 1.5 公里内的超市、小店和餐馆。",
    "places.useLocation": "用我的位置",
    "places.locationHint": "位置会四舍五入到约 100 米，只用来查找附近商家，不会保存。",
    "places.search.label": "搜索地点",
    "places.search.placeholder": "城市、街道或邮编",
    "places.search.none": "没有找到这个地点，换个名字试试。",
    "places.search.results": "选择一个地点",
    "places.searchArea": "搜索这一带",
    "places.around": "{place}附近",
    "places.around.me": "你的位置",
    "places.around.map": "地图区域",
    "places.filter": "按类型筛选",
    "places.filter.all": "全部",
    "places.filter.supermarket": "超市",
    "places.filter.shop": "商店",
    "places.filter.food": "餐饮",
    "places.none": "这附近没有找到商家。可以拖动地图，再点“搜索这一带”。",
    "places.directions": "路线",
    "places.osm": "OpenStreetMap",
    "places.website": "网站",
    "places.hours": "营业时间",
    "places.showOnMap": "在地图上显示 {name}",
    "places.map": "附近商家地图",
    "places.you": "你在这里",
    "places.searchCentre": "搜索中心",
    "places.loading": "正在查找附近商家…",
    "places.mapLoading": "正在加载地图…",
    "places.credits": "地图数据 © OpenStreetMap 贡献者",
    "places.error.busy": "地图服务有点忙，请过一分钟再试。",
    "places.error.denied": "没有定位权限。你可以搜索一个地点，或在浏览器设置中允许定位。",
    "places.error.locate": "暂时无法获取你的位置，请搜索一个地点。",

    "places.detail.supermarket": "超市",
    "places.detail.convenience": "便利店",
    "places.detail.greengrocer": "果蔬店",
    "places.detail.butcher": "肉店",
    "places.detail.bakery": "面包店",
    "places.detail.organic": "有机食品店",
    "places.detail.health_food": "健康食品店",
    "places.detail.deli": "熟食店",
    "places.detail.farm": "农场直销",
    "places.detail.seafood": "海鲜店",
    "places.detail.restaurant": "餐馆",
    "places.detail.cafe": "咖啡馆",
    "places.detail.fast_food": "快餐",
    "places.detail.marketplace": "市场",
  },
  en: {
    "places.offers.title": "Offers and tips",
    "places.offers.all": "All",
    "places.business.title": "For businesses: let families nearby find you",
    "places.business.body": "Supermarkets, shops, restaurants and services can show their offers here. Leave your details and we'll be in touch soon.",
    "places.business.cta": "Contact us",
    "places.business.formTitle": "Advertise with NutriCart",
    "places.business.formIntro": "Fill in the details below and we'll reply within 2 working days.",
    "places.business.name": "Business name",
    "places.business.kind": "Type",
    "places.business.contact": "Contact person",
    "places.business.replyTo": "E-mail or phone",
    "places.business.replyToPh": "So we can reply",
    "places.business.city": "City",
    "places.business.message": "Message (optional)",
    "places.business.messagePh": "e.g. we'd like to promote an opening offer",
    "places.business.send": "Send",
    "places.business.sent": "Sent — we'll be in touch soon. Thank you!",
    "places.title": "Shops nearby",
    "places.heroSub": "Partner offers, plus supermarkets, shops and places to eat around you.",
    "places.type.supermarket": "Supermarket",
    "places.type.shop": "Shop",
    "places.type.food": "Food & drink",
    "places.type.service": "Service",

    "places.partners": "Partners",
    "places.partners.offer": "Offer",
    "places.partners.website": "Visit website",
    "places.partners.none.title": "Want your shop here?",
    "places.partners.none.body": "Send us an email and we'll tell you how it works.",
    "places.partners.none.soon": "Contact details coming soon.",
    "places.copy": "Copy email address",
    "places.copied": "Email address copied",
    "places.copyFailed": "Couldn't copy. Press and hold the address to select it.",

    "places.near": "Near you",
    "places.near.intro": "Use your location or search for a place to see supermarkets, shops and places to eat within about 1.5 km.",
    "places.useLocation": "Use my location",
    "places.locationHint": "Your location is rounded to about 100 m, only used to find places nearby, and never saved.",
    "places.search.label": "Search for a place",
    "places.search.placeholder": "City, street or postcode",
    "places.search.none": "No places found. Try another name.",
    "places.search.results": "Pick a place",
    "places.searchArea": "Search this area",
    "places.around": "Around {place}",
    "places.around.me": "your location",
    "places.around.map": "the map area",
    "places.filter": "Filter by type",
    "places.filter.all": "All",
    "places.filter.supermarket": "Supermarkets",
    "places.filter.shop": "Shops",
    "places.filter.food": "Food & drink",
    "places.none": "Nothing found around here. Move the map and tap “Search this area”.",
    "places.directions": "Directions",
    "places.osm": "OpenStreetMap",
    "places.website": "Website",
    "places.hours": "Opening hours",
    "places.showOnMap": "Show {name} on the map",
    "places.map": "Map of places nearby",
    "places.you": "You are here",
    "places.searchCentre": "Search centre",
    "places.loading": "Looking for places nearby…",
    "places.mapLoading": "Loading the map…",
    "places.credits": "Map data © OpenStreetMap contributors",
    "places.error.busy": "The map service is busy, try again in a minute.",
    "places.error.denied": "Location access is off. Search for a place instead, or allow location in your browser settings.",
    "places.error.locate": "Couldn't get your location. Search for a place instead.",

    "places.detail.supermarket": "Supermarket",
    "places.detail.convenience": "Convenience store",
    "places.detail.greengrocer": "Greengrocer",
    "places.detail.butcher": "Butcher",
    "places.detail.bakery": "Bakery",
    "places.detail.organic": "Organic shop",
    "places.detail.health_food": "Health food shop",
    "places.detail.deli": "Deli",
    "places.detail.farm": "Farm shop",
    "places.detail.seafood": "Fishmonger",
    "places.detail.restaurant": "Restaurant",
    "places.detail.cafe": "Café",
    "places.detail.fast_food": "Fast food",
    "places.detail.marketplace": "Market",
  },
  nl: {
    "places.offers.title": "Aanbiedingen en tips",
    "places.offers.all": "Alles",
    "places.business.title": "Voor ondernemers: laat gezinnen in de buurt je vinden",
    "places.business.body": "Supermarkten, winkels, restaurants en dienstverleners kunnen hier hun aanbiedingen tonen. Laat je gegevens achter, dan nemen we snel contact op.",
    "places.business.cta": "Neem contact op",
    "places.business.formTitle": "Adverteren bij NutriCart",
    "places.business.formIntro": "Vul de gegevens hieronder in; we antwoorden binnen 2 werkdagen.",
    "places.business.name": "Naam van de zaak",
    "places.business.kind": "Soort",
    "places.business.contact": "Contactpersoon",
    "places.business.replyTo": "E-mail of telefoon",
    "places.business.replyToPh": "Zodat we kunnen antwoorden",
    "places.business.city": "Plaats",
    "places.business.message": "Bericht (optioneel)",
    "places.business.messagePh": "bijv. we willen een openingsaanbieding promoten",
    "places.business.send": "Versturen",
    "places.business.sent": "Verstuurd — we nemen snel contact op. Bedankt!",
    "places.title": "Winkels in de buurt",
    "places.heroSub": "Aanbiedingen van partners, plus supermarkten, winkels en eetplekken bij jou in de buurt.",
    "places.type.supermarket": "Supermarkt",
    "places.type.shop": "Winkel",
    "places.type.food": "Eten & drinken",
    "places.type.service": "Dienst",

    "places.partners": "Partners",
    "places.partners.offer": "Aanbieding",
    "places.partners.website": "Naar website",
    "places.partners.none.title": "Je winkel hier?",
    "places.partners.none.body": "Stuur ons een e-mail, dan vertellen we hoe het werkt.",
    "places.partners.none.soon": "Contactgegevens volgen binnenkort.",
    "places.copy": "E-mailadres kopiëren",
    "places.copied": "E-mailadres gekopieerd",
    "places.copyFailed": "Kopiëren lukte niet. Houd het adres ingedrukt om het te selecteren.",

    "places.near": "Bij jou in de buurt",
    "places.near.intro": "Gebruik je locatie of zoek een plek om supermarkten, winkels en eetplekken binnen ongeveer 1,5 km te zien.",
    "places.useLocation": "Mijn locatie gebruiken",
    "places.locationHint": "Je locatie wordt afgerond op ongeveer 100 m, alleen gebruikt om plekken in de buurt te vinden en nooit bewaard.",
    "places.search.label": "Zoek een plek",
    "places.search.placeholder": "Stad, straat of postcode",
    "places.search.none": "Geen plekken gevonden. Probeer een andere naam.",
    "places.search.results": "Kies een plek",
    "places.searchArea": "Zoek in dit gebied",
    "places.around": "Rond {place}",
    "places.around.me": "jouw locatie",
    "places.around.map": "het kaartgebied",
    "places.filter": "Filter op soort",
    "places.filter.all": "Alles",
    "places.filter.supermarket": "Supermarkten",
    "places.filter.shop": "Winkels",
    "places.filter.food": "Eten & drinken",
    "places.none": "Hier niets gevonden. Verschuif de kaart en tik op “Zoek in dit gebied”.",
    "places.directions": "Route",
    "places.osm": "OpenStreetMap",
    "places.website": "Website",
    "places.hours": "Openingstijden",
    "places.showOnMap": "{name} op de kaart tonen",
    "places.map": "Kaart met plekken in de buurt",
    "places.you": "Je bent hier",
    "places.searchCentre": "Zoekpunt",
    "places.loading": "Plekken in de buurt zoeken…",
    "places.mapLoading": "Kaart laden…",
    "places.credits": "Kaartgegevens © OpenStreetMap-bijdragers",
    "places.error.busy": "De kaartdienst is druk, probeer het over een minuut opnieuw.",
    "places.error.denied": "Locatietoegang staat uit. Zoek een plek, of sta locatie toe in je browserinstellingen.",
    "places.error.locate": "Je locatie kon niet worden bepaald. Zoek in plaats daarvan een plek.",

    "places.detail.supermarket": "Supermarkt",
    "places.detail.convenience": "Buurtsuper",
    "places.detail.greengrocer": "Groenteboer",
    "places.detail.butcher": "Slager",
    "places.detail.bakery": "Bakker",
    "places.detail.organic": "Biologische winkel",
    "places.detail.health_food": "Reformwinkel",
    "places.detail.deli": "Delicatessenzaak",
    "places.detail.farm": "Boerderijwinkel",
    "places.detail.seafood": "Viswinkel",
    "places.detail.restaurant": "Restaurant",
    "places.detail.cafe": "Café",
    "places.detail.fast_food": "Snackbar",
    "places.detail.marketplace": "Markt",
  },
} satisfies Dict;
